import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Zonetail from './zonetail-explore-library';
import Home from './web/pages/home/Home';
import Explore from './web/pages/Explore';
import Contact from './web/pages/contact/Contact';
import { ServerConfigs } from './api/adserver';
import RootOverlays from './components/RootOverlays';
import analytics from './lib/wrapAnalytics';

Zonetail.init({
  advertAgeApiDev: ServerConfigs.adserverBase,
  advertAgeApiProd: ServerConfigs.adserverBase,
  pmsApiDev: ServerConfigs.zonetailHomeServerBase,
  pmsApiProd: ServerConfigs.zonetailHomeServerBase,
  analytics: analytics,
});

const containerStyle = {
  display: 'flex',
  flex: 1,
  maxWidth: 1200,
  width: '100%',
  alignContent: 'flex-start',
  justifyContent: 'flex-start',
  alignSelf: 'center',
};

const App: React.FC = () => {
  return (
    <Router>
      <RootOverlays />
      <div style={containerStyle}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/explore" component={Explore} />
          <Route exact path="/explore/:building_id" component={Explore} />
          <Route exact path="/contact" component={Contact} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
